import Vue from "vue";
import Router from "vue-router";

import LoginLawyer from "./views/lawyer/Login";
import RegisterLawyer from "./views/lawyer/Register";
import ProfileLawyer from "./views/lawyer/Account";
import AccountRule from "./views/lawyer/Rule.vue";

import Form from "./views/Form.vue";
import Lawyer from "./views/Lawyer.vue";
import Register from "./views/Register.vue";
import Profile from "./views/profile/Profile.vue";

import Landing from "./views/Landing.vue";
import About from "./views/About.vue";
import Article from "./views/Article.vue";
import NotFound from "./views/global/NotFoundPage";
import Rule from "./views/Rule.vue";
import Blogs from "./views/Blogs.vue";

import Teams from "./views/Teams";
import Download from "./views/Download";
import Visa from "./views/Visa.vue";
import Contact from "./views/Contact";

import AppHeader from "./views/global/AppHeader";
import AppFooter from "./views/global/AppFooter";
import Booking from "@/views/Booking";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};
Vue.use(Router);

export default new Router({
    mode: 'history',
    linkExactActiveClass: "active",
    routes: [
        {
            path: "/",
            name: "landing",
            components: {
                header: AppHeader,
                default: Landing,
                footer: AppFooter
            },
            meta: {
                title: "Landing",
                authorize: false
            }
        },
        {
            path: "/about",
            name: "about",
            components: {
                header: AppHeader,
                default: About,
                footer: AppFooter
            },
            meta: {
                title: "About",
                authorize: false
            }
        },
        {
            path: "/download",
            name: "download",
            components: {
                header: AppHeader,
                default: Download,
                footer: AppFooter
            },
            meta: {
                title: "Download",
                authorize: false
            }
        },
        {
            path: "/contact",
            name: "contact",
            components: {
                header: AppHeader,
                default: Contact,
                footer: AppFooter
            },
            meta: {
                title: "Contact us",
                authorize: false
            }
        },
        {
            path: "/rules",
            name: "rules",
            components: {
                header: AppHeader,
                default: Rule,
                footer: AppFooter
            },
            meta: {
                title: "Terms of use",
                authorize: false
            }
        },
        {
            path: "/booking/reservations/gateway",
            name: "booking",
            components: {
                default: Booking,
                header: AppHeader,
            },
            meta: {
                title: "Terms of use",
                authorize: false
            }
        },
        {
            path: "/article/:id?",
            name: "article",
            components: {
                header: AppHeader,
                default: Article,
                footer: AppFooter
            },
            meta: {
                title: "Article",
                authorize: false
            }
        },
        {
            path: "/blog",
            name: "blog",
            components: {
                header: AppHeader,
                default: Blogs,
                footer: AppFooter
            },
            meta: {
                title: "Blogs & News",
                authorize: false
            }
        },
        {
            path: "/consultants",
            alias: ["/team"],
            name: "teams",
            components: {
                header: AppHeader,
                default: Teams,
                footer: AppFooter
            },
            meta: {
                title: "Find a consultant",
                authorize: false
            }
        },
        {
            path: "/form",
            name: "form",
            components: {
                header: AppHeader,
                default: Form,
                footer: AppFooter
            },
            meta: {
                title: "Discover immigration programs",
                authorize: false
            }
        },
        {
            path: "/consultant/:id?",
            alias: ["/lawyer"],
            name: "lawyer",
            components: {
                header: AppHeader,
                default: Lawyer,
                footer: AppFooter
            },
            meta: {
                title: "Consultant Info",
                authorize: false
            }
        },
        {
            path: "/visa/:id?",
            name: "visa",
            components: {
                header: AppHeader,
                default: Visa,
                footer: AppFooter
            },
            meta: {
                title: "Visa Info",
                authorize: false
            }
        },
        {
            path: "/register",
            name: "register",
            alias: ['/login'],
            components: {
                header: AppHeader,
                default: Register,
                footer: AppFooter
            },
            meta: {
                title: "Sign In",
                authorize: false
            }
        },
        {
            path: "/profile",
            name: "profile",
            components: {
                header: AppHeader,
                default: Profile,
                footer: AppFooter
            },
            meta: {
                title: "My Dashboard",
                authorize: true
            }
        },
        {
            path: "/accounts/rules",
            name: "accountRules",
            components: {
                header: AppHeader,
                default: AccountRule,
                footer: AppFooter
            },
            meta: {
                title: "Terms of use",
                authorize: false
            }
        },
        {
            path: "/accounts",
            name: "profile-lawyer",
            components: {
                header: AppHeader,
                default: ProfileLawyer,
                footer: AppFooter
            },
            meta: {
                title: "Account Manager",
                authorize: true,
                authenticate: true
            }
        },
        {
            path: "/accounts/login",
            name: "login-lawyer",
            components: {
                header: AppHeader,
                default: LoginLawyer,
                footer: AppFooter
            },
            meta: {
                title: "Sign In",
                authorize: false,
                authenticate: true
            }
        },
        {
            path: "/accounts/register",
            name: "register-lawyer",
            components: {
                header: AppHeader,
                default: RegisterLawyer,
                footer: AppFooter
            },
            meta: {
                title: "Sign Up",
                authorize: false,
                authenticate: true
            }
        },
        {path: "*", name: "404", component: NotFound, meta: {title: "", authorize: false}}
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return {selector: to.hash};
        } else {
            return {x: 0, y: 0};
        }
    }
});
